import { SET_ABOUT_DATA, SET_COURSE_DATA, SET_FAQ_DATA, SET_HOME_DATA, SET_LOADING, SET_PAGE, SET_PRIVACY_DATA, SET_SETTING_DATA, SET_TERMS_DATA } from "./Action";

const initialState = {
    isLoading: true,
    homepageData:"",
    aboutpageData:"",
    privacyData:"",
    termsData:"",
    faqData: "",
    courseData: "",
    settingData: "",
    currentPage:"",
  };

  const reducer=(state=initialState,{type,payload})=>{
    switch (type){
        case SET_LOADING:
            return{ ...state, isLoading: payload };
            case SET_PAGE:
                return{ ...state, currentPage: payload };

      case SET_HOME_DATA:
        return{ ...state, homepageData: payload };
     
      case SET_ABOUT_DATA:
        return { ...state, aboutpageData: payload };
      
      case SET_PRIVACY_DATA:
        return { ...state, privacyData: payload };
        case SET_TERMS_DATA:
          return { ...state, termsData: payload };
          case SET_FAQ_DATA:
          return { ...state, faqData: payload };
          case SET_COURSE_DATA:
            return { ...state, courseData: payload };
      case SET_SETTING_DATA:
        return { ...state, settingData: payload };
        default:
            return state;
    }
  }


  export default reducer